module.exports = __webpack_public_path__ + "static/talk-8-be513efd5a40fc5ff5b86178cb7969ba.png";